import { render, staticRenderFns } from "./main-section-dashboard.vue?vue&type=template&id=2c95554b&scoped=true"
import script from "./main-section-dashboard.vue?vue&type=script&lang=js"
export * from "./main-section-dashboard.vue?vue&type=script&lang=js"
import style0 from "./main-section-dashboard.vue?vue&type=style&index=0&id=2c95554b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c95554b",
  null
  
)

export default component.exports